import FiltersHeader from "../../../../Helper/filtersHeader";
import * as Constants from '../../../../Helper/constants/constants';
import { Col, Container, Form, Image, Row } from "react-bootstrap";
import { Calender, ChangePatientProfile, Patient } from "../../../../../assets/images";
import CustomTab from "../../../../Helper/customTabs";
import { useState } from "react";
import DemographicDetailTab from "../../../Tabs/DemographicDetail";
import AddressTab from "../../../Tabs/Address";
import ConsultantTab from "../../../Tabs/Consultant";
import GeneralTab from "../../../Tabs/General";

const AddPatient = () => {
    const breadcrumData = ['Dashboard', 'Manage Patient'];
    const breadcrumItem = ['Add Patient'];
    const [currentTab, setCurrentTab] = useState('1');
    const tabs = [
        {
            id: 1,
            tabTitle: 'Demographic Detail',
        },
        {
            id: 2,
            tabTitle: 'Address',
        },
        {
            id: 3,
            tabTitle: 'Consultant',
        },
        {
            id: 4,
            tabTitle: 'General',
        }
    ];

    return (
        <div className="add_patient_screen">
            <FiltersHeader header={Constants.ADD_PATIENT} breadcrumData={breadcrumData} breadcrumItem={breadcrumItem} />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Form>
                            <div className="patient_profile_area">
                                <div className="patient_profile">
                                    <Image src={Patient} alt="..." />
                                </div>
                                <div className="change_profile">
                                    <Image src={ChangePatientProfile} alt="..." />
                                </div>
                            </div>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    UH Id<span>*</span>
                                </Form.Label>
                                <Form.Control type="text" placeholder="7DH5738H" required />
                            </Form.Group>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            MR Id<span>*</span>
                                        </Form.Label>
                                        <Form.Control type="text" placeholder="7DH5738H" required />
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Date<span>*</span>
                                        </Form.Label>
                                        <Form.Control type="date" placeholder="DD/MM/YYYY" required />
                                        {/* <div className="date_img">
                                            <Image src={Calender} alt="..." />
                                        </div> */}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Patient Name<span>*</span>
                                </Form.Label>
                                <Form.Control type="text" placeholder="Harjinder Singh" required />
                            </Form.Group>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Ward<span>*</span>
                                </Form.Label>
                                <Form.Control type="text" placeholder="Radiology" required />
                            </Form.Group>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Room No<span>*</span>
                                        </Form.Label>
                                        <Form.Select required>
                                            <option disabled selected>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form.Group className="form-group">
                                        <Form.Label>
                                            Bed No<span>*</span>
                                        </Form.Label>
                                        <Form.Select required>
                                            <option disabled selected>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="form-group">
                                <Form.Label>
                                    Patient Type<span>*</span>
                                </Form.Label>
                                <Form.Select required>
                                    <option value="1">General Patient</option>
                                    <option value="2">Package Patient</option>
                                    <option value="3">Impan Patient</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Check
                                type="checkbox" className="emergency_checkbox"
                                id="Emergency Admission"
                                label="Emergency Admission"
                            />
                        </Form>
                    </Col>
                </Row>
            </Container>
            <div className="task_btn_area">
                <CustomTab
                    tabs={tabs}
                    currentTab={currentTab}
                    setCurrentTab={(e) => setCurrentTab(e)}
                />
            </div>
            <div className="tab_details">
                <div className="custom_tab_data">
                    {parseInt(currentTab) === 1 ? <DemographicDetailTab /> : null}
                    {parseInt(currentTab) === 2 ? <AddressTab /> : null}
                    {parseInt(currentTab) === 3 ? <ConsultantTab /> : null}
                    {parseInt(currentTab) === 4 ? <GeneralTab /> : null}
                </div>
            </div>
        </div>
    )
};

export default AddPatient;